//imports
import { useSelector } from "react-redux";
import { RootState } from "../../../globals";
import { FullSizeModalControllerProps } from "./interfaces";
import { useAtrasCierra } from "../../../utils/atrasCierra";

//view
import FullSizeModalView from "./fullSizeModalView";

const FullSizeModalController = ({
    title,
    show,
    headerContent,
    bodyContent,
    footerContent,
    onClose,
}: FullSizeModalControllerProps) => {

    //useSelector
    const idleLocked : boolean = useSelector((state : RootState) => state.idleLockSwitch.value);

    /*
        El boton "atras" del telefono cierra esta ventana en vez de sacar de WAPP.
        Se le pasa "show" para que solo cuente mientras esta abierta: a diferencia
        de las fichas, esta se queda montada y se esconde. (Esteban, 2026-09-20)
    */
    useAtrasCierra(onClose, show);

    return (
        show?
        <FullSizeModalView
            title = {title}
            onClose = {onClose}
            idleLocked = {idleLocked}
            headerContent = {headerContent}
            bodyContent = {bodyContent}
            footerContent = {footerContent}
        />
        :
        <></>
    )
}

export default FullSizeModalController